import { Directive, ViewContainerRef } from '@angular/core';

@Directive({ selector: '[hvac-content-header-host]' })
export class ContentHeaderHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
